import { normalizeBaseUrl } from '@skychat/shared-core';
import { runtimeApiBaseUrl } from '../../games/services/gameService';

export const MOBILE_DEVICE_KIND = 'mobile';
const MOBILE_DEVICE_SESSION_KEY = 'skychat_device_session_id_mobile';

function randomDeviceSessionSuffix(): string {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID().replace(/-/g, '');
    const bytes = new Uint8Array(16);
    globalThis.crypto?.getRandomValues?.(bytes);
    if (bytes.some(Boolean)) return Array.from(bytes).map((byte) => byte.toString(16).padStart(2, '0')).join('');
  } catch {}
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function getOrCreateMobileDeviceSessionId(): string {
  try {
    const existing = localStorage.getItem(MOBILE_DEVICE_SESSION_KEY);
    if (existing?.startsWith('mobile_')) return existing;
    const next = `mobile_${randomDeviceSessionSuffix()}`;
    localStorage.setItem(MOBILE_DEVICE_SESSION_KEY, next);
    return next;
  } catch {
    return `mobile_${randomDeviceSessionSuffix()}`;
  }
}

export async function postMobileDeviceConnection(apiBaseUrl: string, authToken: string | null, deviceSessionId: string): Promise<void> {
  if (!authToken || !deviceSessionId) return;
  const baseUrl = normalizeBaseUrl(apiBaseUrl || runtimeApiBaseUrl());
  const response = await fetch(`${baseUrl}/api/device-connection`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ deviceKind: MOBILE_DEVICE_KIND, deviceSessionId })
  });
  if (!response.ok) throw new Error(`Device connection update failed: HTTP ${response.status}`);
}

export function postMobileDeviceDisconnection(apiBaseUrl: string, authToken: string | null, deviceSessionId: string): void {
  if (!authToken || !deviceSessionId) return;
  try {
    const baseUrl = normalizeBaseUrl(apiBaseUrl || runtimeApiBaseUrl());
    void fetch(`${baseUrl}/api/device-disconnection`, {
      method: 'POST',
      keepalive: true,
      headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ deviceKind: MOBILE_DEVICE_KIND, deviceSessionId })
    }).catch(() => undefined);
  } catch {
    // Best effort: Socket disconnect and server cleanup still handle stale devices.
  }
}
